import React from "react";
import { ArrowRight, ArrowUpRight, Play, Sparkles } from "lucide-react";
import { PageShell } from "../components/Layout";
import { InfoCard, Logos, pics } from "../components/Cards";
import "./About.css";

export default function About() {
  return (
    <PageShell>
      <main className="about container">
        <section
          className="about__hero"
          style={{ backgroundImage: `url(${pics[6]})` }}
        >
          <div className="about__hero-shade" />
          <div className="about__hero-copy">
            <p className="eyebrow">Our story, quietly told</p>
            <h1>
              Our journey
              <br />
              <em>feels like home.</em>
            </h1>
            <p>
              We create thoughtfully hosted spaces where every arrival feels a
              little more personal.
            </p>
          </div>
          <div className="about__year">
            <b>1989</b>
            <span>
              the year our story
              <br />
              began to unfold
            </span>
          </div>
          <div className="about__hero-nav">
            <span>01</span>
            <span className="about__hero-nav--active">02</span>
            <span>03</span>
            <span>04</span>
          </div>
        </section>
        <section className="about__proof">
          <div>
            <b>1,745,678+</b>
            <span>beautiful stays, and counting</span>
          </div>
          <div>
            <Sparkles />
            <p>
              Each room begins with a simple belief:
              <br />
              <strong>hospitality should feel human.</strong>
            </p>
          </div>
          <a href="#essentials">
            Discover our standard <ArrowRight size={16} />
          </a>
        </section>
        <section className="about__letter">
          <div className="about__letter-copy">
            <p className="eyebrow">More than a place to sleep</p>
            <h2>
              Made for moments that
              <br />
              <em>stay with you.</em>
            </h2>
            <p>
              Bryan Residence began with a desire to make travel feel less
              temporary. Our spaces are designed with warmth, curiosity and the
              small comforts that make a meaningful difference.
            </p>
            <span>
              <br />
              <small>Founder, Bryan Residence</small>
            </span>
          </div>
          <div
            className="about__letter-image"
            style={{ backgroundImage: `url(${pics[2]})` }}
          >
            {/* <button>
              <Play fill="currentColor" size={16} />
            </button>
            <p>
              This is Us
              <br />
              <small>02:14 minutes</small>
            </p> */}
          </div>
        </section>
        <section className="about__essentials" id="essentials">
          <div className="about__essentials-heading">
            <p className="eyebrow">What guides every stay</p>
            <h2>the essentials</h2>
            <p>Carefully considered touches that make every stay effortless.</p>
          </div>
          <div className="about__essentials-cards">
            {[
              ["Cleanliness", "Freshly prepared, deeply cared for."],
              ["Reservation", "Simple from search to arrival."],
              ["Accessibility", "Comfort made for everyone."],
              ["Location", "Connected to what matters."],
              ["Amenities", "Everything needed, nothing extra."],
              ["Safety", "A quiet confidence throughout."],
            ].map(([x, y], i) => (
              <InfoCard
                key={x}
                title={x}
                text={y}
                icon={i === 3 ? "map" : i === 5 ? "shield" : "wifi"}
              />
            ))}
          </div>
          <div
            className="about__plant"
            style={{ backgroundImage: `url(${pics[1]})` }}
          >
            <span>
              Thoughtful living,
              <br />
              wherever you land.
            </span>
          </div>
        </section>
        <section className="about__together">
          <div style={{ backgroundImage: `url(${pics[3]})` }} />
          <div>
            <p className="eyebrow">The Bryan Residence promise</p>
            <b>4510+</b>
            <h2>
              Dedicated to exceeding your
              <br />
              <em>expectations,</em> every time.
            </h2>
            <p>
              Comfort and satisfaction, designed around the people who matter
              most: you.
            </p>
            <a href="/accommodation">
              Explore our spaces <ArrowUpRight size={15} />
            </a>
          </div>
        </section>
        {/* <Logos /> */}
      </main>
    </PageShell>
  );
}
